import React from 'react'

const IconLearning = props => (
  <svg viewBox="0 0 20 20" {...props}>
    <path
      fill="#09C5B8"
      d="M5.975 6.4c-2.2 2.2-2.2 5.8 0 8s5.8 2.2 8 0 2.2-5.8 0-8l1.5-1.5c3.1 3.1 3.1 8.1 0 11.1s-8.1 3.1-11.1 0c-3.1-3.1-3.1-8.1 0-11.1"
    />
    <path
      fill="#28D88C"
      d="M7.675 7.1c-1.2 1.2-3.3 1.2-4.4 1.2-.4 0-.7-.3-.7-.7-.1-1.1-.1-3.2 1.1-4.4s3.4-1.3 4.4-1.2c.4 0 .7.3.7.7.1 1.1.1 3.2-1.1 4.4zM13.195 5.334l-1.3 1.2-1.4-1.4c-.3-.3-.3-.9 0-1.2.3-.3.9-.3 1.2 0l1.5 1.4zM15.129 3.4l-1.3 1.2-1.4-1.4c-.3-.3-.3-.9 0-1.2.3-.3.9-.3 1.2 0l1.5 1.4z"
    />
    <path
      fill="#28D88C"
      d="M17.395 6l-2.8 2.8c-.3.3-.8.3-1.1 0l-1.5-1.5c-.3-.3-.3-.8 0-1.1l2.8-2.8c.3-.3.8-.3 1.1 0l1.5 1.5c.3.3.3.8 0 1.1z"
    />
  </svg>
);

export default IconLearning



// WEBPACK FOOTER //
// ./src/components/SVG/Navbar/IconLearning.js